import { Box, Chip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { ORDER_STATUS } from "../../../constants/enums";
import { useEffect } from "react";

const ViewOrder = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const orderData = location.state?.order;

    useEffect(() => {
        if (!orderData) {
            navigate("/manage-order");
        }
    }, [orderData, navigate]);

    if (!orderData) return null;

    const getStatusText = (status: number) => {
        switch (status) {
            case ORDER_STATUS.PENDING: return "Pending";
            case ORDER_STATUS.ACCEPTED: return "Accepted";
            case ORDER_STATUS.PREPARING: return "Preparing";
            case ORDER_STATUS.READY_FOR_PICK_UP: return "Ready for Pickup";
            case ORDER_STATUS.PICKED_UP: return "Picked Up";
            case ORDER_STATUS.ON_THE_WAY: return "On the Way";
            case ORDER_STATUS.DELIVERED: return "Delivered";
            case ORDER_STATUS.CANCELLED_BY_USER: return "Cancelled by User";
            case ORDER_STATUS.CANCELLED_BY_STORE: return "Cancelled by Store";
            default: return "Unknown";
        }
    };

    return (
        <>
            <div className="main_title">
                <h1>View Order Details</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate(-1)}>Manage Orders</button> - View Order
                </p>
            </div>

            <div className="cards view_page">
                <div className="gap_p">

                    {/* Order ID */}
                    <div className="w_33">
                        <h6>Order ID</h6>
                        <p>#{orderData._id?.toUpperCase()}</p>
                    </div>
                    <div className="w_33">
                        <h6>Status</h6>
                        <p>{getStatusText(orderData.status)}</p>
                    </div>

                    {/* User Details */}
                    <div className="w_33 vew_img">
                        <h6>Delivery Address</h6>
                        <Box className="user_block">
                            {/* User image if available, else placeholder */}
                            <figure>
                                <img
                                    src={orderData.user?.profilePhoto || "/static/images/user_placeholder.png"}
                                    alt="User"
                                    onError={(e) => { (e.target as HTMLImageElement).src = "/static/images/user_placeholder.png" }}
                                />
                            </figure>
                            <p>
                                <b>{orderData.deliveryAddress?.name}</b>
                                {orderData.deliveryAddress?.address}, {orderData.deliveryAddress?.city}<br />
                                {orderData.deliveryAddress?.state}, {orderData.deliveryAddress?.pincode}<br />
                                Phone: {orderData.deliveryAddress?.phone}
                            </p>
                        </Box>
                    </div>

                    {/* Items Details */}
                    <div className="w_100">
                        <h6>Order Items ({orderData.suborders?.length || 0})</h6>
                        {orderData.suborders?.map((item: any, idx: number) => (
                            <div key={idx} className="item_row" style={{ borderBottom: '1px solid #eee', padding: '10px 0', display: 'flex', gap: '20px', alignItems: 'center' }}>
                                <img src={item.product?.image} alt={item.product?.name} style={{ width: '60px', height: '60px', borderRadius: '8px', objectFit: 'cover' }} />
                                <div>
                                    <p style={{ fontWeight: 'bold', margin: 0 }}>{item.product?.name}</p>
                                    <p style={{ margin: 0, fontSize: '12px', color: '#666' }}>
                                        Qty: {item.quantity} | Price: ${item.price}
                                    </p>
                                    {/* Show flavors/toppings if any */}
                                </div>
                                <div style={{ marginLeft: 'auto' }}>
                                    <p style={{ fontWeight: 'bold' }}>${item.totalPrice}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Payment Details */}
                    <div className="w_33">
                        <h6>Grand Total</h6>
                        <p>${orderData.grandTotal}</p>
                    </div>
                    <div className="w_33">
                        <h6>Payment Mode</h6>
                        <p>{orderData.paymentMode === 1 ? "Cash" : "Online"}</p>
                    </div>
                    <div className="w_33">
                        <h6>Payment Status</h6>
                        <Chip
                            label={orderData.paymentStatus === 1 ? "Pending" : orderData.paymentStatus === 3 ? "Completed" : "Failed"}
                            color={orderData.paymentStatus === 3 ? "success" : "warning"}
                            size="small"
                        />
                    </div>

                    <div className="w_33">
                        <h6>Order Date</h6>
                        <p>{moment(orderData.createdAt).format("DD MMM YYYY, hh:mm A")}</p>
                    </div>

                </div>
            </div>
        </>
    );
};

export default ViewOrder;
